/* Shoppable room: tags on the photo open their line in the list. */
const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
function initRoom(room) {
  if (room._laReady) return;
  room._laReady = true;
  const spots = Array.from(room.querySelectorAll('[data-la-spot]'));
  const items = Array.from(room.querySelectorAll('[data-la-spot-item]'));
  spots.forEach((s) => s.addEventListener('click', () => {
    const on = s.getAttribute('aria-expanded') !== 'true';
    spots.forEach((x) => x.setAttribute('aria-expanded', 'false'));
    items.forEach((x) => x.classList.remove('is-active'));
    if (!on) return;
    s.setAttribute('aria-expanded', 'true');
    const item = room.querySelector(`[data-la-spot-item="${s.dataset.laSpot}"]`);
    if (!item) return;
    item.classList.add('is-active');
    if (innerWidth < 1040) item.scrollIntoView({ block: 'nearest', behavior: reduced() ? 'auto' : 'smooth' });
  }));
}
const run = (scope = document) => scope.querySelectorAll('[data-la-room]').forEach(initRoom);
run();
document.addEventListener('shopify:section:load', (e) => run(e.target));
